import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    // SEO
    SEO_TITLE: 'Collaborator detail | Legal alerts Mexico | Crehana',
    SEO_DESCRIPTION:
      'Check the weekly overtime breakdown of a collaborator against the Mexican legal caps.',

    // Header
    HEADER_TITLE: 'Collaborator detail',
    HEADER_TITLE_WITH_NAME: 'Collaborator detail: {{name}}',
    BUTTON_BACK: 'Back',

    // Week navigator
    WEEK_NAVIGATOR_LABEL: 'Week of {{start}} to {{end}}',
    WEEK_NAVIGATOR_PREV: 'Previous week',
    WEEK_NAVIGATOR_NEXT: 'Next week',
    // Same MR !257 rationale as EDIT_WORKDAY_DIALOG_TITLE_DATE_PATTERN: `en`
    // gets its own month-first pattern instead of the `es` connector leaking in.
    WEEK_NAVIGATOR_END_DATE_PATTERN: 'MMMM d, yyyy',
    WEEK_NAVIGATOR_START_DATE_PATTERN_CROSS_MONTH: 'MMMM d',

    // State labels
    STATE_NO_ALERTS: 'No alerts',
    STATE_AT_RISK: 'At risk',
    STATE_EXCEEDED: 'Exceeded',
    STATE_NO_DATA: 'No data',

    // Table
    DETAIL_TABLE_TITLE: 'Legal alerts detail',

    // Columns
    COL_DATE: 'Date',
    COL_SHIFT: 'Shift',
    COL_WORKED_TIME: 'Worked time',
    COL_EXTRA_TIME: 'Overtime',
    COL_COMPENSATED_TIME: 'Compensated time',
    COL_STATE: 'State',

    // Rows
    CAP_LABEL: 'Cap: {{value}}',
    // !402 review, hilo DOS — a PROPOSAL, pending Laura's confirmation. Do
    // not mark this copy as approved.
    CAP_LABEL_NOT_EVALUATED: 'Legal cap: {{value}}',
    ROW_TOTAL: 'Week total',
    TODAY_LABEL: 'Today',
    EMPTY_VALUE: '—',

    // Errors
    FORBIDDEN_TITLE: 'You do not have access',
    FORBIDDEN_DESCRIPTION: 'You do not have permission to view this data.',
    NOT_AUTHENTICATED_TITLE: 'Your session is not valid',
    NOT_AUTHENTICATED_DESCRIPTION:
      'Sign in again to see the collaborator detail.',
    VALIDATION_TITLE: 'The collaborator is not valid',
    VALIDATION_DESCRIPTION:
      'Check the link or go back to the legal alerts list.',
    BUTTON_BACK_TO_LIST: 'Back to the list',
    ERROR_TITLE: 'An error occurred',
    ERROR_DESCRIPTION: 'An error occurred. Click the button to retry.',
    ERROR_RETRY: 'Retry',
  },
};
